// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const AssetMaterialDeleteApiAssetsAssetIdMaterialsMaterialIdDeleteParams = zod.object({
  "revision": zod.int().min(1)
})

export type AssetMaterialDeleteApiAssetsAssetIdMaterialsMaterialIdDeleteParams = zod.input<typeof AssetMaterialDeleteApiAssetsAssetIdMaterialsMaterialIdDeleteParams>;
export type AssetMaterialDeleteApiAssetsAssetIdMaterialsMaterialIdDeleteParamsOutput = zod.output<typeof AssetMaterialDeleteApiAssetsAssetIdMaterialsMaterialIdDeleteParams>;
